module.exports = __webpack_public_path__ + "23c1cf357a696836913e071e69a183f4.MP3";